// extracted by mini-css-extract-plugin
module.exports = {"cell":"Params_cell__1G0bs","own":"Params_own__vudmz","name":"Params_name__2gTWx","title":"Params_title__3M0zV"};